module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAJxJREFUSEtjZKAxYKSx+QyjFhAM4dEgGkRB1ODAwCIrLdPMwMCQAnXWnMdPn9Q2HGD4Q64cyBx4JM+Plmn/z8hYgezn////dyQvfVJJrhyKBXOjZV4zMjKKoAXqi6QljyXJlaOvBdiCgfH//45EHEFEjByKD0ARKS8t0/wPGslMDAxzHiJFMjlyKBYQTNBkKhgtKggG3GgQjYAgAgAgH4QZ/FYyWgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bookIcons/limit1.png
// module id = J1ic
// module chunks = 1